<select class="form-control" name="sysUserGroup" id="sysUserGroup">
    <option value="" disabled selected>Nhóm người dùng</option>
    <option *ngFor="let item of sysusergroup" value="item"> {{item.name}}</option>
</select>